import React from "react";
import { Check } from "lucide-react";
import { yenFmt, limitLabel } from "@/lib/plans";

export function PlanCards({ plans, cycle, currentPlan, onSelect, busyPlan }) {
  return (
    <div className="grid md:grid-cols-3 gap-4" data-testid="plan-cards">
      {plans.map((p) => {
        const price = cycle === "monthly" ? p.price_monthly : p.price_yearly;
        const isCurrent = currentPlan === p.key;
        const highlight = p.key === "standard";
        return (
          <div
            key={p.key}
            className={`relative rounded-lg border p-6 flex flex-col ${
              highlight ? "border-brand shadow-sm" : "border-border"
            } bg-white`}
            data-testid={`plan-card-${p.key}`}
          >
            {highlight && (
              <span className="absolute -top-2.5 left-6 bg-brand text-white text-[10px] font-medium px-2 py-0.5 rounded-sm">
                人気
              </span>
            )}
            <div className="text-sm font-medium text-muted-foreground">{p.name}</div>
            <div className="mt-2 flex items-baseline gap-1">
              <span className="font-display text-3xl font-light">{yenFmt(price)}</span>
              <span className="text-xs text-muted-foreground">/{cycle === "monthly" ? "月" : "年"}</span>
            </div>
            <div className="mt-1 text-[11px] text-muted-foreground">
              物件 {limitLabel(p.max_properties)} ・ ユーザー {limitLabel(p.max_users)}
            </div>
            <ul className="mt-4 space-y-2 flex-1">
              {p.features.map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-[13px] text-gray-700">
                  <Check className="w-4 h-4 text-brand shrink-0 mt-0.5" />
                  {f}
                </li>
              ))}
            </ul>
            {onSelect && (
              <button
                disabled={isCurrent || busyPlan === p.key}
                onClick={() => onSelect(p.key)}
                data-testid={`plan-select-${p.key}`}
                className={`mt-5 h-10 rounded-sm text-sm font-medium transition-colors ${
                  isCurrent
                    ? "bg-gray-100 text-gray-400 cursor-default"
                    : "bg-brand hover:bg-brand-hover text-white"
                }`}
              >
                {isCurrent ? "利用中のプラン" : busyPlan === p.key ? "処理中..." : "このプランにする"}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
